import { render, staticRenderFns } from "./ProjectSettingPersonnel.vue?vue&type=template&id=6f093c66&scoped=true"
import script from "./ProjectSettingPersonnel.vue?vue&type=script&lang=js"
export * from "./ProjectSettingPersonnel.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingPersonnel.vue?vue&type=style&index=0&id=6f093c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f093c66",
  null
  
)

export default component.exports